import React from 'react';
import ReactDOM from 'react-dom/client';
import { AppThemeProvider } from './contexts/app-theme';
import { AppProvider } from './contexts/app';
import { QueryClientProvider } from 'react-query';
import queryClient from './lib/query-client';
import { SnackbarProvider } from 'notistack';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { ModalProvider } from './contexts/modal';
import RouteProvider from './router/provider';
import { initDatadog } from './lib/datadog';
import Environment from './lib/environment';
import ErrorBoundary from './components/error-boundary';
import { HotkeysProvider } from 'react-hotkeys-hook';
import { EmitterProvider } from './contexts/emitter';
import AssumeRoleToast from './components/toasts/assume-role';
import { printConsoleBanner } from './lib/helpers';
import { FeatureProvider } from './contexts/feature';
import { UserSettingsProvider } from './contexts/user-settings';

initDatadog();
printConsoleBanner();
console.log(`build v${APP_VERSION}-${Environment.MODE}`);

// https://notistack.com/features/customization#custom-variant-(typescript)
declare module 'notistack' {
  interface VariantOverrides {
    assumeRole: true;
  }
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AppThemeProvider>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <ErrorBoundary>
          <AppProvider>
            <EmitterProvider>
              <QueryClientProvider client={queryClient}>
                <FeatureProvider>
                  <HotkeysProvider>
                    <ModalProvider>
                      <UserSettingsProvider>
                        <SnackbarProvider Components={{ assumeRole: AssumeRoleToast }}>
                          <RouteProvider />
                        </SnackbarProvider>
                      </UserSettingsProvider>
                    </ModalProvider>
                  </HotkeysProvider>
                </FeatureProvider>
              </QueryClientProvider>
            </EmitterProvider>
          </AppProvider>
        </ErrorBoundary>
      </LocalizationProvider>
    </AppThemeProvider>
  </React.StrictMode>
);
